module.exports = __webpack_public_path__ + "static/w-1-09fce73a184bf3fb5788b7c0e5c5f974.svg";